import {
  getTotalFinancialsStatistics,
  selectState,
} from "../slices/TotalFinancialsStatistics.slice";
import { useSelector } from "react-redux";
import { selectState as mainSelectState } from "../slices/main.slice";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import Loader from "components/Loader/Loader";
import { FormatNumber} from "../services/statistics.service";
import { mapMonths } from "utils/dateUtils";

export const FinancialStatistics = () => {
  const { statistics, loading } = useSelector(selectState);
  const { mainDateFrom } = useSelector(mainSelectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mainDateFrom != null) {
      dispatch(
        getTotalFinancialsStatistics({ year: mainDateFrom?.getFullYear() })
      );
    }
    console.log(statistics);
  }, [dispatch, mainDateFrom]);

  const getHighest = () => {
    let highest = 0;
    statistics?.monthlyFinancials.forEach((element) => {
      if (element.paidByUs > highest) {
        highest = element.paidByUs;
      }
      if (element.paidToUs > highest) {
        highest = element.paidToUs;
      }
    });
    return highest;
  };

  const getWidth = (num: number | undefined) => {
    if (num === 0) {
      return 1;
    }
    if (num) {
      const result = 100 / (getHighest() / num);
      return Math.round(result);
    }
  };

  return (
    <div className="extendedDiv">
      <div className="header">Finansije</div>
      <div className="graphs  loading-container">
        {loading && <Loader />}
        <div className="graphs-header">
          <span>
            <div className="color7"></div>Platili nama
          </span>
          <span>
            <div className="color16"></div>Mi platili
          </span>
        </div>
        <div className="graphs-content loading-container">
          <div className="financialGraphs">
            <div className="financialSideDiv">
              {statistics?.monthlyFinancials &&
                statistics.monthlyFinancials.map((s) => (
                  <span
                    className={`singleFinancial-${getWidth(s.paidToUs)}`}
                  >
                    <div className="color7"></div>
                    <p>{FormatNumber(s.paidToUs)}</p>
                  </span>
                ))}
                <p className="totalRight">{FormatNumber(statistics?.paidToUsTotal)} rsd</p>
            </div>
            <div className="months">
              {statistics?.monthlyFinancials &&
                statistics.monthlyFinancials.map((s) => (
                  <div className="singleMonth">{mapMonths(s.month)}</div>
                ))}
                <p>{'-'}</p>
            </div>
            <div className="financialSideDiv">
              {statistics?.monthlyFinancials &&
                statistics.monthlyFinancials.map((s) => (
                  <span
                    className={`reversed singleFinancial-${getWidth(s.paidByUs)}`}
                  >
                    <div className="color16"></div>
                    <p>-{FormatNumber(s.paidByUs)}</p>
                  </span>
                ))}
                <p className="totalLeft">{FormatNumber(statistics?.paidByUsTotal)} rsd</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
